import { TFunction } from 'i18next';

/**
 * Formats attendance time in minutes to a human-readable display.
 * Uses i18n translations for proper localization.
 *
 * @param minutes - Number of minutes to format
 * @param t - i18n translation function
 * @returns Formatted time string (e.g., "2 hrs 30 mins", "1 hr", "45 mins")
 *
 * @example
 * formatAttendanceTimeDisplay(60, t) // "1 hr"
 * formatAttendanceTimeDisplay(90, t) // "1 hr 30 mins"
 * formatAttendanceTimeDisplay(120, t) // "2 hrs"
 * formatAttendanceTimeDisplay(45, t) // "45 mins"
 */
export function formatAttendanceTimeDisplay(minutes: number, t: TFunction): string {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours === 0) {
    return t('eventDetails.shiftDisplay.attendanceTimeInMinutes', {
      minutes: remainingMinutes,
    });
  }
  if (remainingMinutes === 0) {
    return t('eventDetails.shiftDisplay.attendanceTimeInHour', {
      hours: hours,
    });
  }
  return t('eventDetails.shiftDisplay.attendanceTimeInHourAndMinutes', {
    hours: hours,
    minutes: remainingMinutes,
  });
}
